<template>
  <table
    ref="dt-table"
    :id="id"
    :class="`dt-ntable ${id}`"
    :style="{
      '--ntable-th-padding': thpad,
      '--ntable-td-padding': tdpad,
      '--ntable-th-span-padding': thspad,
      '--ntable-th-span-margin': thsmar,
      '--ntable-border-right': tdbdr,
      '--ntable-last-bb': bb,
      ...(height ? { '--ntable-height': height ? height : undefined } : {}),
    }"
  >
    <thead v-if="config.showHeader" :class="getHeaderClass">
      <slot name="thead" v-bind:thcon="thcon" v-bind:thtext="thtext">
        <tr>
          <th
            v-for="header of headers"
            :key="header.value"
            :title="header.text"
            v-bind="thcon(header.value)"
          >
            <span
              :style="{
                textAlign: header.ta || 'left',
              }"
              >{{ thtext(header.value) }}</span
            >
          </th>
        </tr>
      </slot>
    </thead>
    <tbody
      ref="tbody"
      @scroll="onTBBodyScroll"
      :class="{
        'dt-loading': loadingFlag,
        no_row: !items || items.length == 0,
      }"
      v-if="!autoLoad && ((items && items.length > 0) || showNoItems)"
    >
      <template v-for="(item, index) in items">
        <template v-if="item.new_group_title == '1'">
          <slot name="groupIitem" v-bind:item="item" v-bind:index="index">
            <tr class="group_title" :key="item['group_title']">
              <th>
                {{ item.group_title }}
              </th>
            </tr>
          </slot>
        </template>
        <!-- <template v-else> </template> -->
        <slot
          name="item"
          v-bind:item="item"
          v-bind:index="index"
          v-bind:tdcon="tdcon"
        >
          <tr :key="item[config.key]">
            <td v-for="header of headers" :key="header.value">
              {{ item[header.value] }}
            </td>
          </tr>
        </slot>
      </template>
      <div class="no_row" v-if="!items || (items.length == 0 && showNoItems)">
        <div class="no_items_text" v-if="!loadingFlag">
          {{ $t("no_items") }}
        </div>
        <img v-else src="static/icons/loading.gif" alt />
      </div>
    </tbody>
    <tbody
      ref="tbody"
      :class="{
        'dt-loading': loadingFlag,
        no_row: !autoItems || autoItems.length == 0,
        overflow: 'hidden',
      }"
      v-if="autoLoad && ((autoItems && autoItems.length > 0) || showNoItems)"
      @scroll="onAutoTBodyScroll"
    >
      <div
        class="auto-tr-list"
        :style="{
          minHeight: autoItemsHeight ? autoItemsHeight + 'px' : undefined,
          position: 'relative',
          overflowY: 'scroll',
        }"
      >
        <template v-for="(item, index) in autoItems">
          <div
            :key="index"
            class="auto-tr-item"
            :style="{
              top: `${item.y}px`,
              position: 'absolute',
            }"
          >
            <slot
              name="item"
              v-if="autoRowVisible(index)"
              v-bind:item="item"
              v-bind:index="index"
              v-bind:tdcon="tdcon"
            >
              <tr :key="item[config.key]">
                <td v-for="header of headers" :key="header.value">
                  {{ item[header.value] }}
                </td>
              </tr>
            </slot>
          </div>
        </template>
      </div>
      <div
        class="no_row"
        v-if="!autoItems || (autoItems.length == 0 && showNoItems)"
      >
        <div class="no_items_text" v-if="!loadingFlag">
          {{ $t("no_items") }}
        </div>
        <img v-else src="static/icons/loading.gif" alt />
      </div>
    </tbody>
    <div v-if="loadingFlag" class="loading-overlay">
      <img src="static/icons/loading.gif" alt />
    </div>
    <tfoot v-if="config.footer">
      <slot name="tfoot" v-bind:thcon="thcon" v-bind:thtext="thtext"></slot>
    </tfoot>
  </table>
</template>

<script>
import { scrollToWithAnimation } from "../scroller/scrollTo";
import {
  getScrollDimensionY,
  subscribeSubject,
  pixelifyNumber,
  subscribeSubjectND,
} from "../../utility";
import { Point } from "../touch/scroller";
import { createNTableConfig } from ".";
import { setTimeout } from "timers";
import { TableScroller } from "./table-scroller";
import { Subject } from "rxjs";
import { TableStylePropTypes } from "./index";
import { Scroller } from "../../utility/scroller";
import { nextTick } from "process";

export default {
  props: {
    id: {
      type: String,
    },
    items: {
      type: Array,
    },
    config: {
      type: Object,
      default: () => createNTableConfig(),
    },
    headers: {
      type: Array,
      default: () => [],
    },
    loadingFlag: {
      type: Boolean,
      default: false,
    },
    showNoItems: {
      type: Boolean,
      default: true,
    },

    ...TableStylePropTypes,
    scrollTop: {
      default: 0,
      type: Number,
    },
    autoLoad: {
      type: Boolean,
      default: false,
    },
  },
  mounted: function () {
    // console.log(this.$el);
    // console.log("getComputedStyle(temp1).getPropertyValue('--ntable-rowHeight')",
    //   getComputedStyle(this.$el).getPropertyValue('--ntable-rowHeight'))

    if (this.$el.style) {
      // this.$el.style.setProperty('--ntable-rowHeight', `${this.config.rowHeight}px`);
      this.computeRowHeights();

      const scrollbarWidth = getComputedStyle(this.$el).getPropertyValue(
        "--scrollbar-width"
      );
      // console.log(scrollbarWidth);
    }

    // console.log(this.config.fullHeight);

    //
    // if (this.config.fullHeight) {
    //   this.setTableStyleHeight();
    // }
    // Calling the function instead of the flat Code of Checking if FullHeight is true then set Table Style Height
    this.setConditionalFullHeight();

    this.computeStyles();

    // console.log("getComputedStyle(temp1).getPropertyValue('--ntable-rowHeight')",
    //   getComputedStyle(this.$el).getPropertyValue('--ntable-rowHeight'))

    // Subscribing to the Scroll Subject Observable

    subscribeSubject(this, this.scrollSubject, (scrollTop) => {
      const scroller = TableScroller.createScroller(this.$refs["tbody"]);
      // console.log("scroller.scrollPercent", scroller.scrollPercent);
      // console.log(
      //   "     this.config.scrollNextThreshold",
      //   this.config.scrollNextThreshold
      // );

      if (
        scroller.scrollTop > 0 &&
        scroller.scrollPercent > this.config.scrollNextThreshold
      ) {
        this.$emit("scrollnext", scroller.scrollPercent);
        console.log("scrollnext", scroller.scrollPercent);
      }
    });

    this.resizeObserver.observe(this.$el);

    if (this.config.fullHeight) {
      this.parentResizeObserver.observe(this.$el.parentElement);
    }

    subscribeSubject(
      this,
      this.resizeCheckerSubject,
      (height) => {
        // console.log('subscribeSubject', this.id, height);

        this.setHeaderStylePadding();
      },
      50
    );

    // If the fullHeight config is true - only then subscribe to the subject - Increases efficiency for nonFullHeight tables
    if (this.config.fullHeight) {
      subscribeSubject(
        this,
        this.parentResizeCheckerSubject,
        (height) => {
          //  console.log('subscribeSubject', this.id, height);
          this.setConditionalFullHeight();
        },
        10
      );
    }

    // AutoTable ScrollTop Subscription

    subscribeSubjectND(
      this,
      this.autoScrollTopSubject,
      (scrollTop) => {
        //console.log("autoScrollTopSubject", scrollTop);
        this.autoRowVisibleStart =
          Math.floor(this.autoScrollTop / this.config.rowHeight) - 2;
        this.autoRowVisibleEnd =
          this.autoRowVisibleStart + this.config.autoRowVisibleCount;
      },
      100
    );
  },
  destroyed() {
    if (this.$el) {
      this.resizeObserver.unobserve(this.$el);
    }
    if (this.parentResizeObserver && this.$el && this.$el.parentElement) {
      this.parentResizeObserver.unobserve(this.$el.parentElement);
    }
  },
  updated() {
    // Updating Slot Child
    // console.log("beforeUpdate");
    // console.log(this);
  },
  data: function () {
    return {
      bodyScrollTop: 0,

      startPoint: Point.createNil(),
      endPoint: Point.createNil(),
      scroller: TableScroller.createNil(),

      scrollSubject: new Subject(),

      parentResizeObserver: this.getParentResizeObserver(),
      resizeObserver: this.getResizeObserver(),

      resizeCheckerSubject: new Subject(),
      parentResizeCheckerSubject: new Subject(),

      autoScrollTop: 0,
      autoScrollTopSubject: new Subject(),
      autoRowVisibleStart: 0,
      autoRowVisibleEnd: 100,
    };
  },
  watch: {
    items: {
      immediate: true, // It was false before. Why was it false ? Must investigate
      handler: function (newValue, oldValue) {
        // this.setTableStyleHeight();
        this.setHeaderStylePadding();

        // setTimeout(() => {
        // console.log("Log: setTimeout");
        //   this.setHeaderStylePadding();
        // }, 1000);
      },
    },
    //   scrollTop: {
    //     immediate: true,
    //     handler: function (newValue, oldValue) {
    //       console.log();
    //       nextTick(() => {
    //         nextTick(() => {
    //           console.log("ScrollTOp Next Tick", this.$refs?.["tbody"]);
    //           if (this.$refs?.["tbody"]?.scrollTop == 0) {
    //             console.log(
    //               "Settings Scroll Top To Body",
    //               this.$refs["tbody"].scrollTop
    //             );
    //             this.$refs["tbody"].scrollTop = newValue;
    //           }
    //         });
    //       });
    //     },
    //   },
  },
  computed: {
    getHeaderClass: function () {
      return `style${this.config.headerStyle}`;
    },
    autoItems() {
      // Returns the items with the y coordinate of the item based on the index and the rowHeight
      return this.items?.map((item, index) => {
        return {
          ...item,
          y: index * this.config.rowHeight,
        };
      });
    },
    autoItemsHeight() {
      // Returns the height of the total Items Height
      return this.autoItems?.length * this.config.rowHeight || 0;
    },
  },
  methods: {
    onTbodyWheel: function (event) {
      // console.log(event);
      let { deltaY } = event;
      if (deltaY > 0) {
        deltaY = deltaY < 53 ? 53 : deltaY;
      } else {
        deltaY = deltaY > -53 ? -53 : deltaY;
      }
      // this.$refs['scroller'].scrollTop = this.bodyScrollTop + deltaY;

      // event.stopPropagation();
      // event.preventDefault();
      const scroller = TableScroller.createScroller(this.$refs["tbody"]);
      // console.log("scroller.scrollPercent", scroller.scrollPercent);
      // console.log(
      //   "this.config.scrollNextThreshold",
      //   this.config.scrollNextThreshold
      // );
      if (
        scroller.scrollTop > 0 &&
        scroller.scrollPercent > this.config.scrollNextThreshold
      ) {
        this.$emit("scrollnext", scroller.scrollPercent);
      }
    },
    onTBBodyScroll: function (event) {
      // console.log({'datatable.vue:377 event' : event});
      this.$emit("scrolled", event);
      this.scrollSubject.next(event.target.scrollTop);
    },
    onScrollerScroll: function (event) {
      this.setScrollTop(event.target.scrollTop);
    },
    resetScroll: function () {
      this.bodyScrollTop = 0;
      if (this.$refs?.tbody?.scrollTop) {
        this.$refs.tbody.scrollTop = 0;
      }
    },
    setScrollTop: function (value) {
      this.bodyScrollTop = value;
      if (this.$refs?.tbody?.scrollTop) {
        this.$refs.tbody.scrollTop = this.bodyScrollTop;
      }
      // this.$refs["tbody"].scrollTop = this.bodyScrollTop;

      //  Probably a Relic of a Old System ?

      // const { height, scrollHeight, scrollTop, scrollPercent } =
      //   getScrollDimensionY(this.$refs["tbody"]);

      // if (scrollTop > 0 && scrollPercent > this.config.scrollNextThreshold) {
      //   this.$emit("scrollnext", scrollPercent);
      // }
    },
    scrollToBottom() {
      this.$refs["tbody"].scrollTop = this.items.length * this.config.rowHeight;
    },
    onTouchStart: function (event) {
      this.startPoint = Point.createFromTouchEvent(event);
    },
    onTouchMove: function (event) {
      // console.log(event);
      if (this.startPoint) {
        const endPoint = Point.createFromTouchEvent(event);
        this.endPoint = this.endPoint ? this.endPoint : this.startPoint;
        const { xDiff, yDiff } = Point.getDiff(this.endPoint, endPoint);
        this.endPoint = endPoint;
        // console.log({xDiff, yDiff});
        this.$refs["scroller"].scrollTop = this.bodyScrollTop + yDiff;

        event.preventDefault();
      }
    },
    onTouchEnd: function (event) {
      // console.log('onTouchEnd', event);
      this.startPoint = Point.createNil();
      this.endPoint = Point.createNil();
    },
    setHeaderStylePadding: function () {
      this.$nextTick(() => {
        const scroller = TableScroller.createScroller(this.$refs["tbody"]);
        // console.log(this.id, { ...scroller });
        if (scroller.height < scroller.scrollHeight && scroller.height != 0) {
          // console.log("Has ScrollBar", scroller.height, scroller.scrollHeight);
          this.$el.style.setProperty(
            "--ntable-theadr-right",
            `${Scroller.scrollbar_width()}px`
          );
        } else {
          this.$el.style.setProperty("--ntable-theadr-right", `0px`);
        }
      });
    },
    setTableStyleHeight: function () {
      setTimeout(() => {
        // console.log(this.$el.parentElement.getBoundingClientRect())
        const height = this.$el.parentElement.getBoundingClientRect().height;
        // console.log(this.$el.parentElement.getBoundingClientRect().height, 'THISIS', height, this.$el.parentElement.getBoundingClientRect());
        if (this.$el.style) {
          this.$el.style.setProperty("--ntable-height", `${height}px`);
        }
        this.$nextTick(() => {
          this.setHeaderStylePadding();
        });
      }, 1000);
    },
    getScrollbarWidth: function () {
      const scrollbarWidth = this.$el
        ? getComputedStyle(this.$el).getPropertyValue("--scrollbar-width")
        : "0px";

      // console.log("Log: scrollbarWidth", scrollbarWidth)
      return scrollbarWidth ? scrollbarWidth : "0px";
    },
    computeStyles: function () {
      if (this.$el.style && this.config.footer) {
        this.$el.style.setProperty(
          "--ntable-footer-height",
          `${this.config.rowHeight}px`
        );
      }
    },
    computeRowHeights: function () {
      if (this.$el && this.$el.style) {
        // if (typeof this.config.rowHeight === 'number') {

        //   this.$el.style.setProperty('--ntable-rowHeight', `${this.config.rowHeight}px`);

        //   if (this.config.footer) {
        //     this.$el.style.setProperty('--ntable-footer-height', `${this.config.rowHeight}px`);
        //   }
        // } else if (typeof this.config.rowHeight === 'string') {

        //   this.$el.style.setProperty('--ntable-rowHeight', `${this.config.rowHeight}`);

        //   if (this.config.footer) {
        //     this.$el.style.setProperty('--ntable-footer-height', `${this.config.rowHeight}`);
        //   }
        // }

        this.$el.style.setProperty(
          "--ntable-rowHeight",
          `${pixelifyNumber(this.config.rowHeight)}`
        );

        if (this.config.footer) {
          this.$el.style.setProperty(
            "--ntable-footer-height",
            `${pixelifyNumber(this.config.rowHeight)}`
          );
        }

        if (this.config.showHeader) {
          if (this.config.headerHeight) {
            this.$el.style.setProperty(
              "--ntable-header-height",
              `${pixelifyNumber(this.config.headerHeight)}`
            );
          } else {
            this.$el.style.setProperty(
              "--ntable-header-height",
              `${pixelifyNumber(this.config.rowHeight)}`
            );
          }
        } else {
          this.$el.style.setProperty("--ntable-header-height", `0px`);
        }
      }
    },
    thcon: function (key) {
      const header = this.headers?.find((e) => e.value == key);
      return {
        class: key,
        style: {
          flex: header?.f,
          maxWidth: header?.mw ? `${header?.mw}px` : undefined,
          minWidth: header?.minw ? `${header?.minw}px` : undefined,
        },
      };
    },
    tdcon: function (key) {
      const header = this.headers?.find((e) => e.value == key);
      return {
        class: key,
        style: {
          flex: header?.f,
          maxWidth: header?.mw ? `${header?.mw}px` : undefined,
          minWidth: header?.minw ? `${header?.minw}px` : undefined,

          fontWeight: header?.fw,
          color: header?.c,
          textAlign: header?.ta,
        },
      };
    },
    thtext: function (key) {
      const header = this.headers?.find((e) => e.value == key);
      if (header.text === "") {
        return ``;
      } else if (header.text && header.text.length > 0) {
        return this.$t(header.text);
      } else if (header.value) {
        return `${this.$t(header.value)}`;
      }
    },

    setConditionalFullHeight() {
      if (this.config.fullHeight) {
        this.setTableStyleHeight();
      }
    },

    getResizeObserver: function () {
      return new ResizeObserver((entries) => {
        for (let entry of entries) {
          if (this.id == "catalog-releases-related-link") {
            // console.log("observeResize", entry);
          }
          if (entry && entry.contentBoxSize) {
            // Checking for chrome as using a non-standard array
            if (entry.contentBoxSize[0]) {
              this.resizeCheckerSubject.next(entry.contentBoxSize[0].blockSize);
            } else {
              this.resizeCheckerSubject.next(entry.contentBoxSize.blockSize);
            }
          } else {
          }
        }
        // console.log("Size changed");
      });
    },
    getParentResizeObserver: function () {
      if (!this.config.fullHeight) {
        return null;
      }
      return new ResizeObserver((entries) => {
        for (let entry of entries) {
          if (this.id == "catalog-releases-related-link") {
            // console.log(
            //   "parentResize observeResize",
            //   entry,
            //   entry.contentBoxSize
            // );
          }
          if (entry && entry.contentBoxSize) {
            // Checking for chrome as using a non-standard array
            if (entry.contentBoxSize[0]) {
              this.parentResizeCheckerSubject.next(
                entry.contentBoxSize[0].blockSize
              );
            } else {
              this.parentResizeCheckerSubject.next(
                entry.contentBoxSize.blockSize
              );
            }
          } else {
          }
        }
        // console.log("Size changed");
      });
    },

    autoRowVisible(index) {
      return (
        index >= this.autoRowVisibleStart && index < this.autoRowVisibleEnd
      );
    },
    onAutoTBodyScroll(event) {
      // const scrollTop = event.target.scrollTop;
      this.autoScrollTop = event.target.scrollTop;
      // console.log({
      //   "datatable.vue:611 this.autoScrollTop": this.autoScrollTop,
      // });
      this.autoScrollTopSubject.next(event.target.scrollTop);
    },
    // MARK: Methods
  },
};
</script>

<style lang="scss">
// Make a mixin that will be reusable
@mixin reusableTbodyTr {
  display: flex;
  width: 100%;

  height: var(--ntable-rowHeight);
  min-height: var(--ntable-rowHeight);
  border-bottom: 1px solid var(--row-bottom-border-color);
  transition: 200ms;

  /* &:not(.group_title):hover {
        background: var(--ntable-hover-color);
      }
      &.selected {
        background: var(--ntable-hover-color);
      } */
  &.group_title {
    padding: var(--ntable-th-span-margin);
    cursor: inherit;
    th {
      color: var(--text-accent);
      font-weight: inherit;
    }
  }

  td {
    // line-height: 8px;      // Problem with Dropdown inside the td
    overflow: hidden;
    word-wrap: break-word;
    white-space: nowrap;
  }

  td:not(:last-child) {
    border-right: var(--ntable-border-right);
  }

  &:last-child {
    border-bottom: var(--ntable-last-bb);
  }
}

.dt-ntable {
  --ntable-height: 0px;
  --ntable-rowHeight: 40px;
  --ntable-background: var(--col-l10);
  --ntable-theadr-right: 0px;
  --ntable-hover-color: inherit;
  --ntable-td-padding: 0px 10px;
  --ntable-th-padding: 0px 10px;
  --ntable-th-span-padding: 0px;
  --ntable-th-span-margin: 0px 10px;
  --ntable-td-span-margin: 0px 10px;
  --scrollbar-width: 15px;
  --ntable-footer-height: 0px;
  --ntable-header-height: 30px;
  --ntable-column-border-color: transparent;
  --row-bottom-border-color: var(--bc-8);
  --ntable-border-right: 1px solid transparent;
  --ntable-last-bb: 1px solid var(--row-bottom-border-color);

  --ntable-body-color: inherit;
  --ntable-text-align: left;

  width: 100%;
  height: var(--ntable-height);
  table-layout: fixed;
  border-collapse: collapse;
  position: relative;

  // Hover style for Main page Tables
  &.h1 {
    // cursor: pointer;
    --ntable-hover-color: var(--bc-9);
    tbody {
      tr {
        cursor: pointer;
      }
    }
  }

  // Header style for Mainly DBox NTables and other Modal Tables
  &.h2 {
    --ntable-hover-color: var(--sprt-11);
  }

  &.dbox1 {
    --ntable-border-right: 1px solid var(--bc-830);
  }

  // Color profile for DBox NTables
  &.c2 {
    --ntable-body-color: var(--text-primary);
    --ntable-header-color: var(--text-5);
  }

  &:not(.h1) {
    tr {
      cursor: unset;
    }
  }
  // Padding of 0px
  &.p0 {
    --ntable-td-padding: 0px;
    --ntable-th-padding: 0px 10px;
    --ntable-th-span-margin: 0px 10px;
  }

  &.b2 {
    --ntable-column-border-color: rgba(0, 0, 0, 0.12);
  }
  &.ba {
    border: 1px solid var(--ntable-column-border-color);
  }

  thead {
    // Using Transform for scrolling

    // z-index: 1;
    // background: var(--ntable-background);
    // position: absolute;
    // width: 100%;

    tr {
      display: flex;
      height: var(--ntable-header-height);
      border-bottom: 1px solid var(--ntable-bb-color);
      // padding-bottom: 2px;                         // Makes problem with a Cell Border gap

      padding-right: var(--ntable-theadr-right);
    }
    th {
      color: var(--ntable-header-color);
      font-weight: 400;
    }

    &.style1 {
      --ntable-header-color: var(--text-accent);
      --ntable-bb-color: var(--text-accent);
    }
    &.style2 {
      // --ntable-header-color: var(--text-primary);
      --ntable-bb-color: var(--text-secondary);
    }
    &.style3 {
      --ntable-header-color: var(--text-5);
      --ntable-bb-color: var(--text-secondary);
    }
  }

  tbody {
    // Transform Scrolling styles
    // transition: 100ms ease-out;

    color: var(--ntable-body-color);

    width: 100%;
    overflow: auto;
    // --header-offset: calc(var(--ntable-rowHeight))
    // --header-offset: var(--ntable-rowHeight);
    height: calc(
      var(--ntable-height) - var(--ntable-header-height) -
        var(--ntable-footer-height)
    );

    display: flex;
    flex-direction: column;

    &:not(.dt-loading) {
      tr {
        td div .actions {
          visibility: hidden !important;
          display: flex;
          flex-direction: row;
        }
        td div .actionsov {
          justify-content: flex-end;
          display: flex;
          max-width: 200px;
          padding-left: 10px;
          z-index: 9;
          position: absolute;
          right: 36px;
          background: var(--ntable-hover-color);
          visibility: hidden !important;
          height: 98%;
          box-shadow: -20px 0px 10px 1px var(--ntable-hover-color);
        }

        &:not(.group_title):hover {
          background: var(--ntable-hover-color);

          td div .actions {
            visibility: visible !important;
          }
          td div .actionsov {
            visibility: visible !important;
          }
        }
        td.notes:hover ~ td div .actionsov {
          visibility: hidden !important;
        }
        &.selected {
          background: var(--ntable-hover-color);
        }
      }
    }

    // use the mixin here
    // @include reusableTbodyTr;

    tr {
      display: flex;
      width: 100%;

      height: var(--ntable-rowHeight);
      min-height: var(--ntable-rowHeight);
      border-bottom: 1px solid var(--row-bottom-border-color);
      transition: 200ms;

      /* &:not(.group_title):hover {
        background: var(--ntable-hover-color);
      }
      &.selected {
        background: var(--ntable-hover-color);
      } */
      &.group_title {
        padding: var(--ntable-th-span-margin);
        cursor: inherit;
        th {
          color: var(--text-accent);
          font-weight: inherit;
        }
      }

      td {
        // line-height: 8px;      // Problem with Dropdown inside the td
        overflow: hidden;
        word-wrap: break-word;
        white-space: nowrap;
      }

      td:not(:last-child) {
        border-right: var(--ntable-border-right);
      }

      &:last-child {
        border-bottom: var(--ntable-last-bb);
      }
    }

    /* tr:not(.group_title):hover {
      background: var(--ntable-hover-color);
    }
    tr.selected {
      background: var(--ntable-hover-color);
    } */

    &.dt-loading {
      position &::before {
        display: none;
      }
      /* tr {
        border-bottom: transparent !important;
      } */
      tr {
        opacity: 0.65;
        animation: 2s infinite linear;
        animation-name: opacityShimmer;
      }
      /*
      tr::before {
        content: "";
        position: absolute;

        display: block;
        width: 0px;

        left: 0;

        width: 100%;
        border-radius: 3px;
        // background: hsl(0, 0%, 96%);
        z-index: 1;

        background: hsla(0, 0%, 96%, 0.20);
        animation: 3.5s infinite linear;
        
        top: 0px;
        height: 100%;

        // animation-name: placeHolderShimmer;
      } */

      @keyframes opacityShimmer {
        0% {
          /* opacity: 0.35; */
          /* filter: blur(2px); */
          filter: opacity(0.35);
        }
        50% {
          /* opacity: 0.65; */
          /* filter: blur(10px); */
          filter: opacity(0.75);
        }
        100% {
          /* opacity: 0.35; */
          /* filter: blur(2px); */
          filter: opacity(0.35);
        }
      }
      @keyframes placeHolderShimmer {
        0% {
          background: hsl(0, 0%, 95%);
        }
        25% {
          background: hsl(7, 5%, 97%);
        }
        50% {
          background: hsl(5, 7%, 98%);
        }
        100% {
          background: hsl(0, 0%, 95%);
        }
      }
    }
    &.no_row {
      height: var(--ntable-rowHeight);
      /* background: hsla(0, 0%, 89%, 0.5); */

      div.no_row {
        height: var(--ntable-rowHeight);
        display: flex;
        justify-content: center;

        /* padding: 10px; */
        display: flex;
        justify-content: center;
        color: var(--text-secondary);

        .no_items_text {
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
      }
    }
    &.dt-loading:not(.no_row) {
      tr::before {
        top: unset !important;
        height: calc(var(--ntable-rowHeight) - 4px) !important;
        margin: 2px 0px;
      }

      @keyframes placeHolderShimmer {
        0% {
          background: hsl(0, 0%, 95%);
        }
        25% {
          background: hsl(7, 5%, 97%);
        }
        50% {
          background: hsl(5, 7%, 98%);
        }
        100% {
          background: hsl(0, 0%, 95%);
        }
      }
    }

    .auto-tr-list {
      position: relative;
      .auto-tr-item {
        width: 100%;
        height: var(--ntable-rowHeight);
        min-height: var(--ntable-rowHeight);

        tr {
          display: flex;
          width: 100%;

          height: var(--ntable-rowHeight);
          min-height: var(--ntable-rowHeight);
          transition: 200ms;

          &.group_title {
            padding: var(--ntable-th-span-margin);
            cursor: inherit;
            th {
              color: var(--text-accent);
              font-weight: inherit;
            }
          }

          td {
            // line-height: 8px;      // Problem with Dropdown inside the td
            overflow: hidden;
            word-wrap: break-word;
            white-space: nowrap;
          }
          td:not(:last-child) {
            border-right: var(--ntable-border-right);
          }
        }
        border-bottom: 1px solid var(--row-bottom-border-color);
        &:last-child {
          border-bottom: var(--ntable-last-bb);
        }
      }
    }
  }

  .loading-overlay {
    /* height: calc(
      var(--ntable-height) - var(--ntable-header-height) -
        var(--ntable-footer-height)
    ); */

    position: absolute;
    display: grid;
    justify-content: center;
    align-content: center;
    width: 100%;
    height: 100%;
    top: 0px;
    /* height: calc(100% - 165px);
        width: calc(100% - 230px); */
  }

  tfoot {
    height: var(--ntable-footer-height);
    tr {
      height: var(--ntable-footer-height);
      display: flex;
      padding-right: var(--ntable-theadr-right);
    }
  }

  .scroller {
    height: calc(var(--ntable-height) - 40px);
    position: absolute;
    right: 0px;
    top: var(--ntable-rowHeight);
    background: transparent;
    width: 2px;
    overflow-y: auto;
    width: 15px;
  }

  th,
  td {
    text-align: var(--ntable-text-align);
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  th:not(:nth-last-child(1)):not(:nth-last-child(0)) {
    border-right: 1px solid var(--ntable-column-border-color);
  }
  td:not(:last-child) {
    border-right: 1px solid var(--ntable-column-border-color);
  }

  th {
    /* padding: var(--ntable-th-padding); */

    // Text Overflow Ellipsis
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    & > span {
      margin: var(--ntable-th-span-margin);

      text-transform: capitalize;
      /* padding: var(--ntable-th-span-padding); */
    }

    & > div {
      margin: var(--ntable-th-span-margin);
    }
  }

  td {
    /* padding: var(--ntable-td-padding); */

    & > span {
      margin: var(--ntable-td-span-margin);
    }
    & > div:not(.dt-icon-container):not(.fc2):not(.dbox1) {
      margin: var(--ntable-th-span-margin);
    }
    & > input {
      padding: var(--ntable-th-span-margin);
    }

    & > .dt-icon-container {
      margin: auto;
    }
    /* & > .fc2 {
      margin: 0;
    } */
  }

  @media screen and (min-width: 320px) and (max-width: 1024px) {
    --scrollbar-width: 0px;
  }
}
</style>


<style lang="scss">
.dt-ntable {
  .ntable--textfield {
    color: var(--text-primary);
    height: 100%;
    /* padding-left: 10px; */

    &:focus,
    &:active {
      border: 1px solid var(--text-5);
      outline: none;
      background: var(--ntable-hover-color);
    }
  }
  .dropdown {
    color: var(--text-primary);
  }
}
</style>